// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-style-loader!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/css-loader?{"minimize":true,"sourceMap":true}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6fd714a","scoped":false,"hasInlineConfig":false}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=styles&index=0!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-flag-icon/components/icon/Flag.vue
// module id = 674
// module chunks = 29